export const CARD_PAYMENT_METHOD = {
  card: 'card',
  googlePayCard: 'google_pay_card'
};

export const CARD_PAYMENT_METHODS = [CARD_PAYMENT_METHOD.card, CARD_PAYMENT_METHOD.googlePayCard];
